/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomToken } from '../models/custom-token';
import { submitterGetFirebaseJwtApiV2AuthOrgSubmitterTokenGet } from '../fn/auth/submitter-get-firebase-jwt-api-v-2-auth-org-submitter-token-get';
import { SubmitterGetFirebaseJwtApiV2AuthOrgSubmitterTokenGet$Params } from '../fn/auth/submitter-get-firebase-jwt-api-v-2-auth-org-submitter-token-get';

@Injectable({ providedIn: 'root' })
export class AuthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `submitterGetFirebaseJwtApiV2AuthOrgSubmitterTokenGet()` */
  static readonly SubmitterGetFirebaseJwtApiV2AuthOrgSubmitterTokenGetPath = '/api/v2/auth/{org}/submitter/token';

  /**
   * Submitter Get Firebase Jwt.
   *
   * Generates a custom Firebase JWT token for an authenticated submitter.
   *
   * This endpoint validates the submitter's membership within the specified organization
   * and issues a custom Firebase JWT token if authorized. It also increments a Prometheus
   * counter for monitoring token generation requests.
   *
   * Args:
   *     request (Request): The incoming HTTP request object.
   *     claims (str): JWT claims extracted from the request's security header.
   *     db (Any): Database connection instance, resolved via dependency injection.
   *     auth_token (Any): The validated authentication token, containing user details.
   *     org (Any): Organization details resolved from the request path.
   *
   * Returns:
   *     dict: A dictionary containing the generated Firebase JWT token.
   *
   * Raises:
   *     HTTPException:
   *         - 400: If JWT is missing in the request headers.
   *         - 400: If the user is not a member of the specified organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submitterGetFirebaseJwtApiV2AuthOrgSubmitterTokenGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  submitterGetFirebaseJwtApiV2AuthOrgSubmitterTokenGet$Response(params: SubmitterGetFirebaseJwtApiV2AuthOrgSubmitterTokenGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomToken>> {
    return submitterGetFirebaseJwtApiV2AuthOrgSubmitterTokenGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Submitter Get Firebase Jwt.
   *
   * Generates a custom Firebase JWT token for an authenticated submitter.
   *
   * This endpoint validates the submitter's membership within the specified organization
   * and issues a custom Firebase JWT token if authorized. It also increments a Prometheus
   * counter for monitoring token generation requests.
   *
   * Args:
   *     request (Request): The incoming HTTP request object.
   *     claims (str): JWT claims extracted from the request's security header.
   *     db (Any): Database connection instance, resolved via dependency injection.
   *     auth_token (Any): The validated authentication token, containing user details.
   *     org (Any): Organization details resolved from the request path.
   *
   * Returns:
   *     dict: A dictionary containing the generated Firebase JWT token.
   *
   * Raises:
   *     HTTPException:
   *         - 400: If JWT is missing in the request headers.
   *         - 400: If the user is not a member of the specified organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `submitterGetFirebaseJwtApiV2AuthOrgSubmitterTokenGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  submitterGetFirebaseJwtApiV2AuthOrgSubmitterTokenGet(params: SubmitterGetFirebaseJwtApiV2AuthOrgSubmitterTokenGet$Params, context?: HttpContext): Observable<CustomToken> {
    return this.submitterGetFirebaseJwtApiV2AuthOrgSubmitterTokenGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomToken>): CustomToken => r.body)
    );
  }

}
